import React, { Component } from 'react';
import DrawableCanvas from 'react-drawable-canvas';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeMap } from '../../../actions/ts_map_actions.js';
import { updateModal } from '../../../actions/modal.js';
import { updateCanvas } from '../../../actions/ts_canvas_actions.js';
import { setActive } from '../../../actions/ts_active_actions.js';
import { clearDraw } from '../../../actions/ts_overlay_actions.js';
import logger from '../../../actions/log.js';
import Promo from '../../promo/'
import {
  VALORANT,
  BIND,
  HAVEN,
  SPLIT,
  ASCENT
} from '../../../utils/maps/types';
import { Button, Grid, Row, Col, Clearfix, Thumbnail } from 'react-bootstrap';
import bindImg from '../../../images/valorant/bind.png';
import havenImg from '../../../images/valorant/haven.png';
import splitImg from '../../../images/valorant/split.png';
import ascentImg from '../../../images/valorant/ascent.png';

class Valorant extends Component {

  constructor(props) {
      super(props);
  }

changeMap(game,map)
{
  var {overlay} = this.props;
  this.props.changeMap(game,map);
  logger.logMapClick(game,map);
  this.props.clearDraw(overlay.color,overlay.color1,overlay.color2);
  this.props.updateModal(false,null);
  this.props.updateCanvas(null,null,[]);
  this.props.setActive(null,null);
}
    render() {
      var {map} = this.props;
        return (
          <div>
             <Promo/>
                <span className="menuHeaderText">Valorant</span><br/><br/>
                <Row id="divThumbnailBox">
                <Col xs={4} md={4}>
                  <Thumbnail onClick={(event) => {this.changeMap(VALORANT,ASCENT);}} bsClass="thumbnail" src={bindImg} alt="">
                  <span className="thumbnailText"><b>Ascent</b></span><br/>
                  </Thumbnail>
               </Col>
                <Col xs={4} md={4}>
                  <Thumbnail onClick={(event) => {this.changeMap(VALORANT,BIND);}} bsClass="thumbnail" src={bindImg} alt="">
                  <span className="thumbnailText"><b>Bind</b></span><br/>
                  </Thumbnail>
               </Col>
               <Col xs={4} md={4}>
                  <Thumbnail onClick={(event) => {this.changeMap(VALORANT,HAVEN);}} bsClass="thumbnail" src={havenImg} alt="">
                  <span className="thumbnailText"><b>Haven</b></span><br/>
                  </Thumbnail>
                </Col>
                <Col xs={4} md={4}>
                  <Thumbnail onClick={(event) => {this.changeMap(VALORANT,SPLIT);}} bsClass="thumbnail" src={splitImg} alt="">
                  <span className="thumbnailText"><b>Split</b></span><br/>
                  </Thumbnail>
               </Col>
               </Row>
          </div>

        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeMap, clearDraw, updateModal, updateCanvas, setActive
    }, dispatch);
}

function mapStateToProps(state) {
    return { map: state.map, overlay: state.overlay, canvas: state.canvas };
}

export default connect(mapStateToProps, mapDispatchToProps)(Valorant);



// WEBPACK FOOTER //
// ./src/app/components/menu/games/valorant.jsx